<script>
  import { styles } from '../../../helper'

  import Item from './Item.svelte'
  import Overlay from './Overlay.svelte'

  export let assetBlocks, textBlocks

  let additionalData = [
    {
      title: 'Cycle 1',
      start: true,
      color: '#ff3a52ff',
    },
    {
      color: '#ff3a52ff',
      srcThumb: `/assets/images/artwork-preconditions/icon2_100x100.png`,
      srcsetThumb: `/assets/images/artwork-preconditions/icon2_100x100.png 1x, /assets/images/artwork-preconditions/icon2_200x200.png 2x`,
    },
    {
      color: '#ff3a52ff',
      srcThumb: `/assets/images/artwork-preconditions/icon3_100x100.png`,
      srcsetThumb: `/assets/images/artwork-preconditions/icon3_100x100.png 1x, /assets/images/artwork-preconditions/icon3_200x200.png 2x`,
    },
    {
      color: '#ff3a52ff',
      srcThumb: `/assets/images/artwork-preconditions/icon4_100x100.png`,
      srcsetThumb: `/assets/images/artwork-preconditions/icon4_100x100.png 1x, /assets/images/artwork-preconditions/icon4_200x200.png 2x`,
    },
    {
      title: 'Cycle 2',
      start: true,
      color: '#40ff9bff',
    },
    {
      color: '#40ff9bff',
    },
    {
      color: '#40ff9bff',
    },
    {
      color: '#40ff9bff',
    },
    {
      title: 'Cycle 3',
      start: true,
      color: '#bb709dff',
    },
    {
      color: '#bb709dff',
    },
    {
      title: 'Cycle 4',
      start: true,
      color: '#afafafff',
    },
    {
      color: '#afafafff',
    },
  ]

  let selectionIndex = null

  function transformData(item, baseData) {
    let out = { ...baseData, id: item.id }
    if (item.typeHandle === 'imageBlock') {
      out.kind = 'image'
      out.src = item?.imageBlock?.[0]?.url
      out.srcset = `${item?.imageBlock?.[0]?.url} 1x, ${item?.imageBlock?.[0]?.url2x} 2x`
      out.srcThumb = item?.imageBlock?.[0]?.thumbnail
      out.srcsetThumb = `${item?.imageBlock?.[0]?.thumbnail} 1x, ${item?.imageBlock?.[0]?.thumbnail2x} 2x`
    } else if (item.typeHandle === 'videoBlock') {
      out.kind = 'video'
      out.src = item?.vimeoUrl
      // let vimeoId = item?.vimeoUrl.match(/([0-9]+)/)[0]
      // out.srcThumb = `https://i.vimeocdn.com/video/${vimeoId}_100x100`
      // out.srcsetThumb = `https://i.vimeocdn.com/video/${vimeoId}_100x100 1x, https://i.vimeocdn.com/video/${vimeoId}_200x200 2x`
    } else if (item.typeHandle === 'textBlock') {
      out.kind = 'audio'
      out.src = item?.textBlock
      out.srcThumb = '/assets/images/artwork-preconditions/audio.svg'
    }
    return out
  }

  let items = assetBlocks
    .map((block, i) => transformData(block, additionalData?.[i]))
    .map((item, i) => ({
      ...item,
      text: textBlocks?.[i]?.textBlock || '',
    }))

  // console.log({ items })

  let positions = []
  for (let degrees = 180; degrees < 540; degrees += 360 / items.length) {
    positions.push({
      left: Math.cos((Math.PI / 180) * degrees),
      top: Math.sin((Math.PI / 180) * degrees),
    })
  }
  function changeSelectionIndex(offset) {
    if (offset === null) {
      selectionIndex = null
    } else {
      let val = selectionIndex + offset
      selectionIndex =
        val > items.length - 1 ? 0 : val < 0 ? items.length - 1 : val
    }
  }

  $: selection = items[selectionIndex]

  $: document.querySelector('section.almanac-item') &&
    document
      .querySelector('section.almanac-item')
      .style.setProperty('overflow', selection ? 'hidden' : 'auto')
</script>

<svelte:head>
  <link
    href="https://fonts.googleapis.com/css2?family=Arvo:ital@1&display=swap"
    rel="stylesheet"
  />
</svelte:head>

<div class="positioner">
  <div class="container">
    <div
      class="background"
      use:styles={{
        ringColor100: '#ff3a52ff',
        ringColor20: '#ff3a5232',
        ringColor10: '#ff3a521a',
        fillColor: '#ffffff00',
      }}
    >
      <div class="description">
        <p>A durational correspondence piece</p>
        <p>
          {`A search for the traces and
          preconditions of the world
          we want within the world we have`}
        </p>
        <p>A chain of modulations of those traces</p>
        <p>A practice of endurance, repetition, and care</p>
        <div style="width:100%;margin-bottom:1.5vw">
          <span class="arrow-down" />
        </div>
        <p class="small">
          {`Hover over each circle to watch or listen to the
          digital artpiece. Move clockwise in the
          chain to see how it was iterated upon and
          what it was transformed into.`}
        </p>
        <p class="small">Headphones suggested.</p>
      </div>
      {#each positions as position, index}
        <div
          class="itemPoint"
          use:styles={{ top: position.top, left: position.left }}
        >
          <Item
            data={items[index]}
            left={index < 3 || index > 9}
            right={index >= 3 && index <= 9}
            onClick={() => (selectionIndex = index)}
          />
        </div>
      {/each}
    </div>
  </div>
</div>

<div class="quotes">
  <div class="quote1">
    <blockquote>
      {`“In Black culture, according to Snead,
      repetition means that the thing circulates exactly
      in the manner of any flow, including capital flows....
      There is an equilibrium. The thing, the ritual, the dance,
      the beat, is there for you to pick up when you come back to get it.”`}
    </blockquote>
    <footer>Kara Keeling</footer>
  </div>
  <div class="quote2">
    <blockquote>
      {`“For the intersections among spiraling
      trajectories are a matter of care, inexplicable
      care, rogue care, care on the run, a tending not to
      people or by people, but a care that precedes them.”`}
    </blockquote>
    <footer>Abdou Maliq Simone</footer>
  </div>
</div>

{#if selection}
  <Overlay {selection} {changeSelectionIndex} />
{/if}

<style lang="scss">
  :root {
    --highlightColor: #40ff9bff;
  }

  .positioner {
    display: flex;
    width: 100%;
    justify-content: center;
    /* !! hackety hack !! */
    margin-top: calc(10vw - (18vw + 130px));
    @media screen and (min-width: 800px) {
      margin-top: -190px;
    }
  }
  .container {
    display: flex;
    justify-content: center;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 2vw;
    padding: 0;
    margin: 0;
    /* background: #ff05; */
    position: relative;
  }
  .description {
    text-align: center;
    width: 55%;
    margin-top: 5vw;
    font-size: 2vw;
    line-height: 1.4;
    /* background: #f005; */
    position: absolute;
    z-index: 10;
    /* transform: translateX(-50%) translateY(-50%); */
    white-space: pre-line;
    p {
      margin-bottom: 2vw;
    }
    .small {
      font-size: 1.25vw;
      line-height: 1.1;
      margin-bottom: 1.5vw;
    }
    @media screen and (min-width: 800px) {
      font-size: 20px;
      line-height: 28px;
      p {
        margin-bottom: 16px;
      }
      .small {
        font-size: 10px;
        line-height: 12px;
        margin-bottom: 12px;
      }
    }
  }
  .quotes {
    pointer-events: none;
    box-sizing: border-box;
    font-family: Arial, Helvetica, sans-serif;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    width: calc(100vw - 40px);
    margin-left: 20px;
    margin-top: -8vw;
    font-size: 2vw;
    line-height: 1.1;
    text-align: left;
    padding: 10px;
    blockquote {
      white-space: pre-line;
    }
    footer {
      font-size: 120%;
      line-height: 1.4;
    }
    @media screen and (min-width: 920px) {
      flex-direction: row;
      font-size: 16px;
      align-items: end;
    }
    @media screen and (min-width: 1400px) {
      position: relative;
      width: 1400px;
      margin-top: -140px;
      margin-left: calc(50vw - 700px);
    }
  }
  .quote1,
  quote2 {
    padding: 10px;
  }
  .quote2 footer {
    text-align: right;
  }

  .background {
    position: relative;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: radial-gradient(
      circle closest-side,
      var(--fillColor) calc(13% - 2px),
      var(--ringColor10) 13%,
      var(--fillColor) calc(13% + 2px) calc(27% - 2px),
      var(--ringColor10) 27%,
      var(--fillColor) calc(27% + 2px) calc(46% - 2px),
      var(--ringColor20) 46%,
      var(--fillColor) calc(46% + 2px) calc(70% - 2px),
      var(--ringColor100) 70%,
      var(--fillColor) calc(70% + 2px)
    );
    width: calc(100vw - 40px);
    height: calc(100vw - 40px);
    box-sizing: border-box;
    /* background-color: #00f5; */
    @media screen and (min-width: 800px) {
      width: 760px;
      height: 760px;
    }
  }
  .middlePoint {
    width: 100%;
    height: 100%;
    /* background: #f0f; */
    /* position: absolute;
    top: 50%;
    left: 50%; */
  }
  .arrow-down {
    position: relative;
    width: 0;
    height: 3vw;
    top: 3vw;
    border-left: 3vw solid transparent;
    border-right: 3vw solid transparent;
    border-top: 3vw solid #ff3a52ff;
    @media screen and (min-width: 800px) {
      height: 24px;
      top: 24px;
      border-left: 24px solid transparent;
      border-right: 24px solid transparent;
      border-top: 24px solid #ff3a52ff;
    }
  }
  .itemPoint {
    position: absolute;
    width: 10%;
    height: 10%;
    left: calc((var(--left) * 35%) + 50%);
    top: calc((var(--top) * 35%) + 50%);
    transform: translate(-50%, -50%);
    @media screen and (min-width: 800px) {
      width: 80px;
      height: 80px;
    }
  }
</style>
